"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateTimeToYYYYMMDDHHMMString = transformDateTimeToYYYYMMDDHHMMString;
const transformDateToYYYYMMDDString_1 = require("./transformDateToYYYYMMDDString");
const transformTimeToHHMMString_1 = require("./transformTimeToHHMMString");
function transformDateTimeToYYYYMMDDHHMMString(date) {
    return `${(0, transformDateToYYYYMMDDString_1.transformDateToYYYYMMDDString)(date)} ${(0, transformTimeToHHMMString_1.transformTimeToHHMMString)(date)}`;
}
//# sourceMappingURL=transformDateTimeToYYYYMMDDHHMMString.js.map